<template>
	<header>
		<div class="cont">
			<router-link to="/" class="logo" aria-label="Accueil"><img alt="Groupomania Logo" src="../assets/logo.png"></router-link>
			<nav v-show="menuShow">
				<router-link v-if="!logged" to="/login">Se&nbsp;connecter</router-link>
				<router-link v-if="!logged" to="/signup">S'inscrire</router-link>
				<router-link v-if="logged" to="/">Accueil</router-link>
				<router-link v-if="logged" to="/profile">Profile</router-link>
				<a v-if="logged" @click.stop="signout">Déconnexion</a>
			</nav>
			<div class="ddbutton" @click.stop="dropDown" aria-label="menu déroulant"><DropDownButton /></div>
		</div>
	</header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DropDownButton from './DropDownButton.vue'

export default {
	name: 'Header',
	data () { return {
			menuShow: false
		}},
	components: {
		DropDownButton
	},
	computed: {
		...mapState(['logged'])
	},
	methods: {
		...mapActions(['logout']),
		signout() {
			this.logout()
			this.$router.push('/login')
		},
		dropDown() {
			this.menuShow = this.menuShow ? false : true
		},
		windowSizeDropDown() {
			if (document.documentElement.clientWidth >= 992)
				this.menuShow = true
			else
				this.menuShow = false
		}
	},
	mounted() {

		this.windowSizeDropDown()
		window.addEventListener('resize', this.windowSizeDropDown)
		window.addEventListener('click', this.windowSizeDropDown)
	},
	unmounted() {
		window.removeEventListener('resize', this.windowSizeDropDown)
		window.removeEventListener('click', this.windowSizeDropDown)
	},
}
</script>

<style scoped lang="scss">
header {
	height: 80px;
	box-shadow: 0px 2px 6px $color1;	
	background-color: $color1;
	text-align : center;
}
.cont {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 95%;
	height: 100%;
	margin: 0 auto;
}
.logo {
	width: 230px;
}
nav {
	display: flex;
	position: absolute;
	
	flex-wrap: wrap;
	justify-content: flex-end;
	right: 0px;
	top: 80px;
	height: 50px;
	color: $color1;
	font-size: 1.4em;
	font-weight: bold;
	a {
		background-color: white;
		display: flex;
		align-items: center;
		border: solid $color1 1px;
		padding: 0.5em;
		&.router-link-exact-active {
			border-bottom: solid 3px $color2;
		}
	}
}
@include desktop-only {
	.ddbutton {
		display: none;
		margin-right: 20px;
		padding-right: 20px;
	}
	nav {
		color: white;
		position:  static;
		height: 100%;
		a {
			background-color: transparent;
			padding-right: 1em;
			padding-left: 1em;
			border: none;
		}
	}
	header {
		justify-content: space-between;
	}
}
</style>
